export const NO_INTERNET = '処理に失敗しました。もう一度お試しください。';
